/* eslint max-len:0 */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * TwitterIcon Return the twitter icon as a functional Component
 *
 * @param {String} altText for svg alt
 * @returns {Function} icon svg
 * @public
 */
function TwitterIcon({ altText }) {
  // eslint-disable-next-line max-len
  return (
    <>
      <span className='sr-only'>{ altText }</span>
      <svg role='img' aria-labelledby={ altText } xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
        <title id={ altText }>{ altText }</title>
        <path d='M8.3 20.1c7.5 0 11.7-6.3 11.7-11.7v-.5c.8-.6 1.5-1.3 2-2.1-.7.3-1.5.5-2.4.6.9-.5 1.5-1.3 1.8-2.3-.8.5-1.7.8-2.6 1-1.5-1.6-4.1-1.7-5.8-.1-1.1 1-1.5 2.5-1.2 3.9-3.3-.2-6.3-1.7-8.4-4.3-1.1 1.9-.5 4.3 1.3 5.5-.7 0-1.3-.2-1.9-.5v.1c0 2 1.4 3.6 3.3 4-.6.2-1.2.2-1.9.1.5 1.7 2.1 2.8 3.8 2.8-1.5 1.1-3.2 1.8-5.1 1.8-.3 0-.7 0-1-.1 2 1.2 4.2 1.8 6.4 1.8'/>
      </svg>
    </>
  );
}

TwitterIcon.propTypes = {
  altText: PropTypes.string.isRequired
};

export default TwitterIcon;
